import api from '@pray/shared/utils/api';

/**
 * Get impact reports for an artist.
 *
 * @param {Object} params
 * @param {string} params.artistId - The artist UUID
 * @returns {Promise<Object>} List of impact reports
 */
export async function getImpactReports({ artistId }) {
  const url = `/web/studio/artists/${artistId}/analytics/revenue/reports`;
  const response = await api.executeGetRequest(url);
  return response.data.data;
}
